import { mapperTranslation } from '../config/constants';

export const getItemsForEnum = (values: (keyof typeof mapperTranslation)[]) => {
  return values.map(value => ({ value, name: mapperTranslation[value] }));
};
